<template>
  <div class="tw-flex">
    <input
      :id="checkboxId"
      v-model="localCheckboxStatus"
      type="checkbox"
      class="tw-hidden"
      :disabled="!isActive"
    >
    <label
      :for="checkboxId"
      :class="{ 'tw-cursor-pointer': isActive, 'tw-cursor-default': !isActive }"
    >
      <i
        v-if="!localCheckboxStatus"
        :class="['fas fa-square tw-text-[#FCFCFD] tw-border tw-border-solid tw-rounded tw-border-[#D0D4DC]', uncheckedClass]"
      />
      <i
        v-if="localCheckboxStatus"
        :class="['fas fa-check-square tw-text-[#8c67ef] tw-border tw-border-solid tw-rounded tw-border-white', checkedClass]"
      />
    </label>
  </div>
</template>

<script>
export default {
  props: {
    checkedClass: {
      type: String,
      default: '',
    },
    uncheckedClass: {
      type: String,
      default: '',
    },
    value: {
      type: Boolean,
      default: false,
    },
    isActive: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      localCheckboxStatus: this.value,
      checkboxId: '',
    };
  },
  watch: {
    localCheckboxStatus(newValue) {
      this.$emit('input', newValue);
    },
    value(newValue) {
      this.localCheckboxStatus = newValue;
    },
  },
  created() {
    this.checkboxId = 'checkbox-' + Math.random().toString(36).substr(2, 9);
  },
};
</script>
